import get from 'transmute/get';
export const getIncomingThreadId = state => get('incomingThreadId', state);